import React from "react";
import { Loader, Dimmer } from "semantic-ui-react";

const PaymentLoading: React.FC<{ isLoading: boolean }> = ({ isLoading }) => {
  if (isLoading) {
    return (
      <div className="payment-loading">
        <Dimmer active>
          <Loader size="medium">Loading</Loader>
        </Dimmer>
      </div>
    );
  }
  return <></>;
};
export default PaymentLoading;
